import { Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { IconChevronsLeft, IconChevronsRight } from "@/modules/irohana-components/assets/icons";
import { background, button, divider, text } from "@/modules/irohana-components/theme/colors-new";
import { elevation } from "@/modules/irohana-components/theme/variables";
import { isNumber } from "@/modules/irohana-components/utils/number";

type Props = {
  totalPage?: number;
  count?: number;
};

export const PaginationNew: FC<Props> = ({ totalPage }) => {
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(location.search);
  const page = parseInt(query.get("page") || "1");

  const [displayTotalPage, setDisplayTotalPage] = useState<number>(1);

  useEffect(() => {
    if (isNumber(totalPage)) {
      setDisplayTotalPage(totalPage > 0 ? totalPage : 1);
    }
  }, [totalPage]);

  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={page}
        count={displayTotalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => {
          const searchParams = new URLSearchParams(search);
          searchParams.set("page", item.page?.toString() ?? "1");

          return (
            <PaginationItem
              component={Link}
              to={{ pathname, search: searchParams.toString() }}
              slots={{ first: IconChevronsLeft, last: IconChevronsRight }}
              {...item}
              size={"large"}
            />
          );
        }}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)`
  .MuiPaginationItem-root {
    border-radius: 6px;
    margin: 0 4px;
    box-shadow: ${elevation.sm};
    border-color: ${divider.middle};
    color: ${text.secondary};
  }

  .Mui-disabled {
    color: ${text.disable};
    background-color: ${background.disable};
    opacity: 1 !important;
  }

  .Mui-selected:hover {
    cursor: default;
    color: ${text.white};
    background-color: ${background.main} !important;
  }

  .MuiPaginationItem-root {
    &:hover {
      background-color: ${button.hover};
      border-color: ${button.primary};
    }
    &:focus-visible {
      border: 2px solid ${button.tertiary};
    }
    &:active {
      background-color: ${button.primary};
    }
  }

  li:has(> .MuiPaginationItem-previousNext) + li > .MuiPaginationItem-page {
    margin-left: 18px;
  }

  li:has(+ li > .MuiPaginationItem-previousNext) > .MuiPaginationItem-page {
    margin-right: 18px;
  }

  .Mui-selected {
    background-color: ${button.primary} !important;
    color: ${text.white};
  }
`;
